import React, { ReactNode } from 'react';
import { MenuProps } from 'antd';
import { Link } from 'react-router-dom';
import { IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../navbar/NavbarMenu.module.css';

type MenuItemComponents = NonNullable<MenuProps['items']>;

export type BuildableMenuItem = {
	text?: ReactNode;
	icon?: IconDefinition;
	link?: string;
	key?: string;
	hidden?: boolean;
	admin?: boolean;
	management?: boolean;
	children?: BuildableMenuItem[];
};

const buildMenuItemComponents = (menuItems: BuildableMenuItem[]): MenuItemComponents => (
	menuItems
		.filter((i) => !i.hidden)
		.map((item) => {
			delete item.admin;
			delete item.management;

			const {
				children,
				icon,
				text,
				link,
				key,
				...rest
			} = item;

			if (children) {
				return {
					key: (key ?? text) as string,
					label: (
						<>
							{icon && (
								<FontAwesomeIcon
									icon={icon}
									className={styles.menuIcon}
								/>
							)}
							{text}
						</>
					),
					children: buildMenuItemComponents(children),
					...rest,
				};
			}

			return {
				key: link as string,
				label: (
					<Link to={link ?? ''}>
						{icon && (
							<FontAwesomeIcon
								icon={icon}
								className={styles.menuIcon}
							/>
						)}
						{text}
					</Link>
				),
				...rest,
			};
		})
);

export default buildMenuItemComponents;
